import { render, staticRenderFns } from "./PostPreview.vue?vue&type=template&id=f2680578&scoped=true"
import script from "./PostPreview.vue?vue&type=script&lang=js"
export * from "./PostPreview.vue?vue&type=script&lang=js"
import style0 from "./PostPreview.vue?vue&type=style&index=0&id=f2680578&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f2680578",
  null
  
)

export default component.exports